var _path, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradientsparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8232 6.22656V5.17676H17.7734C17.3594 5.17661 17.0235 4.84087 17.0234 4.42676C17.0234 4.01263 17.3593 3.6769 17.7734 3.67676H18.8232V2.62695C18.8234 2.21284 19.1591 1.87697 19.5732 1.87695C19.9874 1.87695 20.3231 2.21283 20.3232 2.62695V3.67676H21.373C21.7872 3.67687 22.123 4.01261 22.123 4.42676C22.123 4.84089 21.7872 5.17665 21.373 5.17676H20.3232V6.22656C20.3231 6.64065 19.9874 6.97656 19.5732 6.97656C19.1591 6.97654 18.8234 6.64064 18.8232 6.22656ZM7.72656 18.8232C7.72656 20.2313 6.58483 21.373 5.17676 21.373C3.76867 21.373 2.62695 20.2313 2.62695 18.8232C2.62697 17.4152 3.76868 16.2734 5.17676 16.2734C6.58482 16.2735 7.72654 17.4152 7.72656 18.8232ZM22.125 11.625C22.125 12.01 21.9901 12.3826 21.7441 12.6787C21.4982 12.9749 21.1567 13.1764 20.7783 13.2471L20.7773 13.2461L15.7783 14.1924C15.5711 14.2316 15.3806 14.3323 15.2314 14.4814C15.0823 14.6306 14.9816 14.8211 14.9424 15.0283L13.9961 20.0273C13.9254 20.4058 13.7249 20.7482 13.4287 20.9941C13.1326 21.2401 12.76 21.375 12.375 21.375C11.99 21.375 11.6174 21.2401 11.3213 20.9941C11.0251 20.7482 10.8236 20.4067 10.7529 20.0283L9.80762 15.0283C9.7684 14.8211 9.66769 14.6306 9.51855 14.4814C9.36941 14.3323 9.17891 14.2316 8.97168 14.1924L3.97168 13.2461C3.59335 13.1754 3.25177 12.9748 3.00586 12.6787C2.75993 12.3826 2.625 12.01 2.625 11.625C2.625 11.24 2.75993 10.8674 3.00586 10.5713C3.25181 10.2751 3.59328 10.0736 3.97168 10.0029L8.97168 9.05762C9.17891 9.0184 9.36941 8.9177 9.51855 8.76855C9.6677 8.61941 9.7684 8.42891 9.80762 8.22168L10.7529 3.22168C10.8236 2.84328 11.0251 2.50181 11.3213 2.25586C11.6174 2.00993 11.99 1.875 12.375 1.875C12.76 1.875 13.1326 2.00993 13.4287 2.25586C13.7249 2.50181 13.9264 2.84328 13.9971 3.22168L14.9424 8.22168C14.9816 8.42891 15.0823 8.61941 15.2314 8.76855C15.3806 8.91769 15.5711 9.0184 15.7783 9.05762L20.7773 10.0029C21.1558 10.0736 21.4982 10.2751 21.7441 10.5713C21.9901 10.8674 22.125 11.24 22.125 11.625Z",
    fill: "url(#paint0_radial_9590_87136)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9590_87136",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.3801 30.1049) rotate(90) scale(30.8389 22.7897)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.251069,
    stopColor: "#001D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#266EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientsparkle);
export default __webpack_public_path__ + "static/media/gradientsparkle.ac824cffd8ed4942b2eb29578abfcac9.svg";
export { ForwardRef as ReactComponent };